import React from 'react';
import Player from 'video.js/dist/types/player';
import VideoJS from '../components/VideoJs';
import { useParams, useSearchParams } from 'react-router-dom';

const WorkScheduleRecordPage = () => {
    const playerRef = React.useRef<Player | null>(null);

    const params = useParams()
    const [searchParams, setSearchParams] = useSearchParams();

    var path = params["path"]! + "?";
    (searchParams.entries() as any).forEach((x: any) => {
        path += `${x[0]}=${encodeURIComponent(x[1])}&`;
    })
    path = path.substring(0, path.length - 1)

    const videoJsOptions = {
        autoplay: true,
        controls: true,
        responsive: true,
        fluid: true,
        sources: [{
            src: path,
            type: 'video/mp4'
        }]
    };

    const handlePlayerReady = (player: Player) => {
        playerRef.current = player;

        // You can handle player events here, for example:
        // player.on('waiting', () => {
        //     videojs.log('player is waiting');
        // });

        // player.on('dispose', () => {
        //     videojs.log('player will dispose');
        // });
    };

    return (
        <>
            <div>Rest of app here</div>
            <VideoJS options={videoJsOptions} onReady={handlePlayerReady} />
            <div>Rest of app here</div>
        </>
    );
}

export default WorkScheduleRecordPage